export class Menu {
	constructor (attributes) {
		var menu = attributes

		if (!menu) return null

		for (let key in menu) {
			this[key] = menu[key]
		}

		var colors = [
			{
				tagName: 'in famiglia',
				color: '#399ec9'
			},
			{
				tagName: 'pronta in 20',
				color: '#399ec9'
			},
			{
				tagName: 'premium',
				color: '#E5C100'
			}
		]

		var icons = [
			{
				tagName: 'vegetariana',
				icon: require('../assets/img/tags/plant.png')
			},
			{
				tagName: 'carne bio',
				icon: require('../assets/img/tags/carne_bio.png')
			},
			{
				tagName: 'pesce azzurro',
				icon: require('../assets/img/tags/fish.png')
			},
			{
				tagName: 'piccante',
				icon: require('../assets/img/tags/chili.png')
			},
			{
				tagName: 'vegana',
				icon: require('../assets/img/tags/plant.png')
			},
			{
				tagName: 'senza uova',
				icon: require('../assets/img/tags/egg.png')
			},
			{
				tagName: 'ricca di omega 3',
				icon: require('../assets/img/tags/fish.png')
			},
			{
				tagName: 'pochi carboidrati',
				icon: require('../assets/img/tags/dumbbell.png')
			},
			{
				tagName: 'pasta senza glutine',
				icon: require('../assets/img/tags/gluten-free.png')
			}
		]
	
		this.recipes.forEach(recipe => recipe.tags.forEach(tag => {
			if (tag.type.toLowerCase() === 'marketing') {
				var color = colors.find(color => tag.name.toLowerCase().includes(color.tagName.toLowerCase()))

				if (color) tag.color = color.color
			}

			if (tag.type.toLowerCase() === 'nutrition') {
				var icon = icons.find(icon => tag.name.toLowerCase().includes(icon.tagName.toLowerCase()))

				if (icon) tag.icon = icon.icon
			}
		}))	

		this.recipes.forEach(recipe => {
			if (recipe.tags.find(tag => tag.name.toLowerCase().includes('box-mixed'))) {
				recipe.isMixedBox = true
			}
		})	


	}
}
